import { Box, Grid } from "@mui/material";
import CustomizedAccordions from "../../components/homepage/accordion";
import ContentCards from "../../components/homepage/contentCards";
import CustomContainer from "../../components/layout/container";
import CustomHeader from "../../components/layout/header";

import AMBSlogos from "../../images/AMBS_Univ_Logo.png"
import GHGMapGreen from "../../images/GHG-MAP_Green.jpg"
import FeedbackOrig from "../../images/FeedbackFaces_Original.jpg"


const AMBSCaseStudy = () => {
  const breadcrumbData = [
    { name: "Home", link: "/" },
    {
      name: `Case Study (AMBS)`,
      link: `/why/case-study/AMBSexecEd`,
    },
  ];

  return (
    <Box>
      <div>
        <title>AMBS - Case Study | MEF</title>
        <meta
          name="description"
          content="Identify & Quantify Macroeconomic/Esg risk"
        />
      </div>
      <CustomHeader
        title={"Client Case Study - Executive Education"}
        breadcrumbData={breadcrumbData}
      />

      <CustomContainer>
        <Box >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={AMBSlogos}
                title="Client Profile- Alliance Manchester Business School"
                objectFit="contain"
                subTitle="Original-Thinking-Applied"
                //example to link in text
                body={`According to the AMBS website:<br>
                "<b>Original</b> ..established in 1965... we aspire to deliver inventive business and management solutions through our world-class research and teaching.
                <b>Thinking</b> - We undertake cutting-edge and influential research which has a transformative impact on policy and practice.
                <b>Applied</b> - We turn theory into practice across all our activity, through our programmes, business engagement and research.
                The Manchester Method, brought to life across all our programmes, focuses on applying theory, through group work, projects and practice-based learning."
                `}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={GHGMapGreen}
                title="Client Needs-Relevant Executive Education"
                objectFit="fill"
                subTitle={`Why AMBS work with MEF - risk2NZ App in the Classroom`}
                body={`MEF's expertise & domain knowledge in the areas of applied Global Economics, GLobalisation/Trade, Financialisation 
                have all been deployed in custom programmes in the AMBS Executive Education offer over the last 20 years, particularly on the
                China program that has engaged with many (now) world-leading Chinese brands.`}
              />
              <CustomizedAccordions
                title="risk2NZ App in Executive Education"
                body={`The risk2NZ App brings real-world data into the ExecEd classroom so that applied learning starts from a base of empirical fact and data.
                Focusing on data-awareness also helps give a comparative perspective given that the risk2NZ datasets are global in nature eg macroeconomic data, 
                Energy demand, Industrial GHG emissions. Once a sound understanding of the data has been laid as a foundation, course material cna then turn to the 
                future and how then future global environment/data may unfold. The ability to stress-test different futures using risk2NZ App brings a new dimension
                of applied risk/sensitivity analysis to tailored course units.`}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={FeedbackOrig}
                objectFit="contain"
                title="Client Feedback"
                subTitle={`Executive Education: MEF Course Creation & Delivery`}
                body={`Dr Alan Wu Executive Director of China Programmes at AMBS Executive Education commented:
                <i>"..we have worked with MEF for almost 15 years in which time they have assisted in devising & delivering custom programs
                from undergraduate Summer Schools to Corporate Executive Education with global-leading brands.
                We use MEF on applied programmes that requires the industry/domain knowledge of practitioner-academics rather than more 
                theoretically-based faculty academics; with MEF's academic connections they can assist us in rebalancing this mix according 
                to the particular client needs."</i><br><br>
                <hr style="color:#00a0a0;height:1px;width:50%;">
                If you would like to initiate an informal chat about how MEF's models/tools/Apps may augment your educational/teaching or CPD offer, please email us
                at: <b style="color:#00a0a0" > education@mef-uk.com </b> `}
              />
              {/* <CustomizedAccordions
                title="Emissions Analysis1"
                body="iGEM allows the feed-through of mGEM global/national shocks to 12 industrial sectors (ISIC Rev. 4) across most/all of the major economies covered by mGEM."
              />
              <CustomizedAccordions
                title="Emissions Analysis2"
                body="SME managers can (cost-effectively) explore potential trading risk & opportunities in key global/national industry sectors. MEF can also construct SME-specific weighted indices of overall export prospects across all the SME's key export markets. mGEM shocks at a global/national level can then be translated into market-specific impacts for tailored SME risk analysis."
              /> */}
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default AMBSCaseStudy;
